<template>
    <div>
        <v-container fluid class="py-0 py-md-3">

            <v-row class="my-10">
                <v-col class="text-center">
                    <div class="d-inline-block pb-6 px-10" style="border-bottom: 1px solid grey;">
                        <!-- <span class="bold product-title" style="font-size: 38px">BEAUTY</span>  -->
                        <span class="product-title" style="font-size: 38px">{{collection.name}}</span>
                    </div>
                </v-col>
            </v-row>

            <v-row class="mb-12" justify="center">
                <v-col cols="10" class="column-especial-4k">
                    
                    <v-row>

                        <template v-for="(product, product_id) in products">
                            <template v-if="productIsInSerie(product)">
                                <v-col cols="12" sm="6" md="6" lg="4"  :key="'product-'+product_id" class="product-column px-sm-12" @mouseover="productOver = product_id" @mouseout="productOver = -1" v-bind:class="{'opac':productOver != -1 && productOver != product_id}">
                                    <router-link :to="'/product/'+product.url" class="mb-5 d-block not-text-decoration">
                                        <v-img :src="'https://www.artlesscms.actstudio.xyz/'+product.cover.path" :contain="true" class="mb-5"></v-img>
                                    </router-link>

                                    <router-link :to="'/product/'+product.url" class="menu-links d-inline-block not-text-decoration furniture-link uppercase">
                                        <span class="bold">{{product.productNameLabelBold}}</span> <span>{{product.productNameLabel}}</span>
                                        <div class="animation-line"></div>
                                    </router-link>
                                </v-col>
                            </template>
                        </template>

                    </v-row>

                </v-col>

                <v-col cols="12" sm="5">
                </v-col>
            </v-row>
        </v-container>
    </div>    
</template>

<script>
export default {
  data() {
    return {
      products: [],
      favorites: [],
      carousel: 0,
      arrowLeft: true,
      arrowRight: true,
      productOver: -1,
      collection: {
          name: ''
      }
    };
  },
  beforeMount: function () {
    var aux = this;
    fetch(
      "https://www.artlesscms.actstudio.xyz/api/collections/get/Products?token=a15be93e9cdb43ca2b3778c2077c26",
      {
        method: "post",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          populate: 1, // resolve linked collection items
          sort:{
                Collection: 1,
                url: 1
            }
        }),
      }
    )
      .then((res) => res.json())
      .then((res) => (aux.products = res.entries));

    fetch(
      "https://www.artlesscms.actstudio.xyz/api/collections/get/Collection?token=a15be93e9cdb43ca2b3778c2077c26",
      {
        method: "post",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          populate: 1, // resolve linked collection items
          filter:{
              url: this.$route.params.url
          }
        }),
      }
    )
      .then((res) => res.json())
      .then((res) => (aux.collection = res.entries[0]));

    fetch(
      "https://www.artlesscms.actstudio.xyz/api/collections/get/Products?token=a15be93e9cdb43ca2b3778c2077c26",
      {
        method: "post",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          filter: {
            favorite: true,
          },
          populate: 1, // resolve linked collection items
        }),
      }
    )
      .then((res) => res.json())
      .then((res) => (aux.favorites = res.entries));
  },
  methods: {
    showPrev: function () {
      if (this.carousel == 0) {
        this.carousel = this.favorites.length - 1;
      } else {
        this.carousel--;
      }
    },
    productIsInSerie: function(product){
        if(product.Collection == undefined){
            console.log('falso')
            return false
        }else{
            if(product.Collection.url == this.$route.params.url){
                return true;
            }
        }

        return false;
        
    }
  },
  computed: {
    path: function () {
      return this.$route.fullPath;
    },
    alto: function () {
      if (this.$vuetify.breakpoint.width >= 2300) {
        return 91;
      } else {
        return 70;
      }
    },
    ancho: function () {
      if (this.$vuetify.breakpoint.width >= 2300) {
        return 260;
      } else {
        return 200;
      }
    },
  },
  mounted() {
    var breadcrumbs = [
      {
        text: "Home",
        link: "/",
        isLink: true,
      },
      {
        text: "Furniture",
        isLink: false,
      },
    ];
    this.$emit("updateStatus", breadcrumbs);
    gtag('config', 'UA-26953667-1', {
      'page_title' : 'Furniture',
      'page_path': '/furniture'
    });
  },
  watch:{
      $route: function(){
          var aux = this;
          fetch(
            "https://www.artlesscms.actstudio.xyz/api/collections/get/Collection?token=a15be93e9cdb43ca2b3778c2077c26",
            {
                method: "post",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                populate: 1, // resolve linked collection items
                filter:{
                    url: this.$route.params.url
                }
                }),
            }
            )
            .then((res) => res.json())
            .then((res) => (aux.collection = res.entries[0]));
      }
  }
};
</script>